<div class="nav-item__lost-sale">
  <!-- Button -->
  <div
    class="nav-item__button-container"
    [ngClass]="{ 'nav-item__button-container--modified': isCalculateLSInProcess }"
  >
    <button
      class="nav-item__button custom-dropdown-item w-100"
      [ngClass]="{ 'nav-item__button--modified': isCalculateLSInProcess }"
      (click)="togglePopup()"
    > 
      <app-icon
        name="calculate-lost-sales"
        class="nav-item__button-icon mr-2"
        [size]="18"
        aria-label="Calculate Lost Sales"
      ></app-icon>Calculate Lost Sales

      <span
      class="nav-item__badge position-absolute translate-middle border border-light rounded-circle"
      [class.nav-item__badge--hidden]="!willRemindToRunCalculate"
      >
      </span>

      <div class="nav-item__timeInfo">
        <ng-container *ngIf="lastCalculated; else introButton">
          <p class="nav-item__timeDetail">
          Last Lost Sales Calculation:
          <br />
          {{ lastCalculated | date : "MM/dd/yyyy 'at' hh:mm a" }}
          </p>
        </ng-container>
        
        <ng-template #introButton>
          <p class="nav-item__timeDetail text-left">Click to calculate Lost Sales</p>
        </ng-template>
      </div>
    </button>
  </div>

   <!-- Spinner -->
  <div class="nav-item__lost-sale-cover" *ngIf="isProcessing">
    <div class="nav-item__lost-sale-cover-content">
      <div class="spinner-border text-light" role="status">
        <span class="sr-only"></span>
      </div>
      <p class="nav-item__lost-sale-cover-message">
        {{ message }}
      </p>
    </div>
  </div>
</div>
